module.exports = __webpack_public_path__ + "static/project1-134611850b85bce10566364386e74756.jpg";